<div class="flex flex-col flex-auto w-full p-8 xs:p-2">
  <div class="flex flex-wrap w-full">
    <div class="flex items-center justify-between w-full my-4 px-4 xs:pr-0">
      <div class="mr-6">
        <h2 class="m-0">
          <span *ngIf="!ui.editingName" (dblclick)="toggleEditingName()">
            {{ dashboard?.name?.trim()?.length ? dashboard?.name : 'Untitled' }}
          </span>
          <mat-form-field class="treo-mat-no-subscript min-w-160" *ngIf="ui.editingName">
            <mat-label></mat-label>
            <input matInput [(ngModel)]="dashboardName" required />
            <button mat-icon-button matSuffix (click)="toggleEditingName()">
              <mat-icon svgIcon="cancel"></mat-icon>
            </button>
            <button mat-icon-button matSuffix (click)="save()" [disabled]="!dashboard?.name">
              <mat-icon svgIcon="save"></mat-icon>
            </button>
          </mat-form-field>
        </h2>
        <div class="text-secondary tracking-tight">Keep track of what's happening.</div>
      </div>
      <div class="flex items-center">
        <ng-container *ngIf="ui.editMode">
          <button mat-icon-button (click)="cancel()" matTooltip="Cancel">
            <mat-icon class="edit-icon" svgIcon="cancel"></mat-icon>
          </button>
          <button mat-icon-button (click)="save()" matTooltip="Save" [disabled]="!dashboard?.name">
            <mat-icon class="edit-icon" svgIcon="save"></mat-icon>
          </button>
        </ng-container>
        <button [appAuthorize]="canShowThreeDotMenu()" class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
          <mat-icon svgIcon="more_vert"></mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
          <button
            *ngIf="!ui.editMode"
            [appAuthorize]="getEditDashboardPermission()"
            (click)="toggleEditMode()"
            matTooltip="Edit Dashboard"
            denyAction="disable"
            mat-menu-item
          >
            <mat-icon svgIcon="edit"></mat-icon>
            Edit Dashboard
          </button>
          <button
            mat-menu-item
            [appAuthorize]="
              (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_DELETE : Permission.DASHBOARDS_DELETE
            "
            (click)="delete()"
            matTooltip="Delete Dashboard"
          >
            <mat-icon svgIcon="delete"></mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<div class="details-report">
  <ng-container *ngIf="selectedDashboard$ | async as selectedDashboard">
    <ng-container *ngIf="selectedDashboard?.charts?.length > 0; else noData">
      <ng-container *ngIf="!ui.editMode; else editModeContainer">
        <div class="flex flex-auto w-full" *ngFor="let chartRow of selectedDashboard.charts; let rowIndex = index">
          <ng-container
            *ngFor="let chartDef of chartRow; let colIndex = index; let firstCol = first; let lastCol = last"
          >
            <div
              class="flex flex-col bg-card shadow-md rounded overflow-hidden h-lane"
              [ngClass]="{ 'w-1/2': chartRow.length == 1 || chartRow.length == 2, 'w-1/3': chartRow.length == 3 }"
              [class.one]="chartRow.length == 1"
            >
              <chart
                [height]="chartRow.length > 2 ? '400px' : '500px'"
                [chartDef]="chartDef"
                [fields]="getFieldDefs(chartDef)"
                [hideEdit]="true"
                [isTimeSeries]="chartDef.isTimeSeries"
                (dataPointSelection)="onDataPointSelection($event, chartDef)"
                [overflowAuto]="chartDef.chart_type === 'table'"
              ></chart>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #editModeContainer>
        <ng-container *ngIf="ui.editMode">
          <div
            class="flex flex-auto w-full"
            *ngFor="
              let chartRow of selectedDashboard.charts;
              let rowIndex = index;
              let firstRow = first;
              let lastRow = last
            "
          >
            <ng-container
              *ngFor="let chartDef of chartRow; let colIndex = index; let firstCol = first; let lastCol = last"
            >
              <div
                class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden m-2 min-h-32 text-center p-8"
              >
                <h6>{{ chartDef?.title }}</h6>
              </div>
              <button
                [appAuthorize]="
                  (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_DELETE : Permission.DASHBOARDS_DELETE
                "
                class="remove-email-field"
                type="button"
                mat-icon-button
                (click)="manageChart('remove', { rowIndex, colIndex })"
                matTooltip="Remove"
              >
                <mat-icon svgIcon="cancel"></mat-icon>
              </button>
              <button
                [appAuthorize]="
                  (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_CREATE : Permission.DASHBOARDS_CREATE_EDIT
                "
                class="add-email-field"
                type="button"
                *ngIf="colIndex < 2"
                mat-icon-button
                (click)="manageChart('addInColumn', { rowIndex })"
                matTooltip="Add"
              >
                <mat-icon svgIcon="add_circle"></mat-icon>
              </button>
              <button
                [appAuthorize]="
                  (newPermissionsEnabled$ | async) ? NewPermission.DASHBOARDS_EDIT : Permission.DASHBOARDS_CREATE_EDIT
                "
                class="add-email-field"
                type="button"
                *ngIf="lastRow && lastCol"
                mat-icon-button
                (click)="manageChart('addInNewRow')"
                matTooltip="Add"
              >
                <mat-icon svgIcon="library_add"></mat-icon>
              </button>
            </ng-container>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>
    <ng-template #noData>
      <div class="details-report__empty">
        <mat-icon class="details-report__empty__report-icon">bar_chart</mat-icon>
        <div class="details-report__empty__prompt">
          <h4>You don't have any charts.</h4>
          <p>
            <mat-icon>lightbulb_outline</mat-icon>
            Start adding charts by clicking&nbsp;<a (click)="manageChart('first')">here</a>.
          </p>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
